var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFindingLeaf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Leaf"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22 3.41L21.88 2.15L20.68 2.55C18.6234 3.26454 16.4273 3.48382 14.27 3.19C12.0031 2.83821 9.68292 3.15082 7.59 4.09C6.48048 4.56245 5.50675 5.30491 4.75747 6.24981C4.0082 7.1947 3.50717 8.31201 3.3 9.5C3.03138 11.0347 3.16576 12.6128 3.69 14.08C4.02755 13.3181 4.422 12.5827 4.87 11.88C5.8862 10.3848 7.29428 9.19818 8.94 8.45C10.5254 7.72613 12.2584 7.38365 14 7.45C12.3422 7.70407 10.7553 8.30001 9.34 9.2C8.6576 9.62903 8.03258 10.1432 7.48 10.73C6.95178 11.3168 6.48594 11.9569 6.09 12.64C5.34666 14.0681 4.81766 15.5978 4.52 17.18C4.1992 18.7673 4.02513 20.3808 4 22H6C6.09503 20.5479 6.29218 19.1044 6.59 17.68C7.97743 18.4292 9.53335 18.8113 11.11 18.79C12.5805 18.789 14.0358 18.4932 15.39 17.92C23 14.67 22 3.86 22 3.41Z",
    fill: "#1E8893"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindingLeaf);
export default __webpack_public_path__ + "static/media/finding-leaf.aed104e8c87c79c945a38f49bf992723.svg";
export { ForwardRef as ReactComponent };